
export const APP_NAME = process.env.REACT_APP_NAME || 'KMJS Rental';

export const dateFormat = 'YYYY-MM-DD';